export { default as Coupe } from './Coupe';
export { default as Hatchback } from './Hatchback';
export { default as Luxury } from './Luxury';
export { default as Minivan } from './Minivan';
export { default as Sedan } from './Sedan';
export { default as Suv } from './Suv';
export { default as Truck } from './Truck';
export { default as Van } from './Van';
export { default as Wagon } from './Wagon';
